import React, { useState, useEffect } from 'react';
import {
  Box,
  Avatar,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Tooltip,
  Spinner,
} from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import MediaDisplay from './MediaDisplay';
import {
  FaRegComment,
  FaHeart,
  FaRegHeart,
  FaShareAlt,
  FaFlag,
} from 'react-icons/fa';
import { FaDotCircle } from 'react-icons/fa';
import moment from 'moment';
import PostTextDisplay from './PostTextDisplay';

const PublicPost = ({ post }) => {
  const [_post, setPost] = useState(post);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);

  useEffect(() => {
    if (post) {
      setPost(post);
    }
  }, [post]);

  useEffect(() => {
    setIsLiked(_post.isLiked);
    setLikesCount(_post.likes_count);
    setCommentsCount(_post.comment_count);
  }, [_post]);

  const goToPost = (e) => {
    navigate(`/public/post?id=${_post.id}`);
  };

  const redirectToLogin = (e) => {
    e.stopPropagation();
    const redirectPath = 'post' + location.search;
    sessionStorage.setItem('_redirectPath', redirectPath);
    navigate('/login', { replace: true });
  };

  return (
    <Box className="w-full flex cursor-pointer items-start gap-2 p-2 pt-5 mb-5">
      <Box className="w-full cursor-pointer flex px-2 flex-col">
        <Box className="w-full pb-5 min-h-10">
          <Box
            onClick={goToPost}
            className="flex items-start gap-4 justify-between"
          >
            <Box className="flex items-start gap-4">
              <Box className="cursor-pointer">
                <Avatar
                  // onClick={redirectToLogin}
                  src={_post.user.profile_image || null}
                  name={`${_post.user.first_name} ${_post.user.last_name}`}
                  size={'md'}
                />
              </Box>
              <Box className="flex flex-col mb-3">
                <Box className="flex flex-row items-center gap-1">
                  <Text
                    as="span"
                    className="font-semibold capitalize"
                    _hover={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: 'blue.600',
                    }}
                    // onClick={redirectToLogin}
                  >
                    {_post.user.first_name} {_post.user.last_name}
                  </Text>
                  <FaDotCircle className="text-[9px]" />
                  <Text
                    as="span"
                    className="font-semibold text-xs text-gray-600 capitalize"
                  >
                    {_post.user.user_type_id == 1
                      ? 'Founder'
                      : _post.user.user_type_id == 2
                        ? 'Investor'
                        : _post.user.user_type_id == 3
                          ? 'Expert'
                          : 'Member'}
                  </Text>
                </Box>
                <Text className="text-xs text-gray-500">
                  {moment(_post.createdAt).fromNow()}
                </Text>
              </Box>
            </Box>
          </Box>

          <PostTextDisplay _post={_post} />
        </Box>
        {_post.media.length > 0 ? <MediaDisplay media={_post.media} /> : null}
        <Box className="flex items-center justify-between">
          <Box
            onClick={redirectToLogin}
            className="flex gap-1 cursor-pointer pr-2  items-center"
          >
            <FaRegComment className="text-gray-600" />
            <Text>{commentsCount}</Text>
          </Box>
          <Box
            onClick={redirectToLogin}
            className="flex gap-1 pr-2 cursor-pointer items-center"
          >
            {isLiked ? (
              <FaHeart className="text-red-600" />
            ) : (
              <FaRegHeart onClick={redirectToLogin} className="text-gray-600" />
            )}

            <Text>{likesCount}</Text>
          </Box>

          <Tooltip
            label="Share post"
            placement="top"
            hasArrow
            bg="gray.700"
            color="white"
            fontSize="sm"
          >
            <Box
              onClick={redirectToLogin}
              className="flex gap-1 cursor-pointer items-center"
            >
              <FaShareAlt />
            </Box>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default PublicPost;
